<template>
  <v-footer
      padless
  >
    <v-container fluid style="padding: 0">
      <v-card
          flat
          tile
          :style="{background: `url('${image}')`}"
          class="text-center"
      >
        <v-card-text>
          <v-btn
              v-for="item in items"
              :key="item.icon"
              class="mx-4"
              icon
              :href="item.href"
              :color="item.color"
          >
            <v-icon x-large>
              {{ item.icon }}
            </v-icon>
          </v-btn>
        </v-card-text>

        <v-card-text style="padding: 0; margin: 0">

          <v-row style="padding: 0 100px">
            <v-col>
              <div class="text-h5 text--primary">
                <v-icon x-large color="primary">mdi-phone</v-icon>İLETİŞİM
              </div>
              <p class="text-body-1">+43 1 239 52 88 <br/>
                <a href = "mailto:info@kasif.eu" class="text-decoration-none">info@kasif.eu</a>
              </p>
            </v-col>
            <v-col>
              <div class="text-h5 text--primary">
                <v-icon x-large color="primary">mdi-map-marker</v-icon>ADRES
              </div>
              <p class="text-body-1">Sechshauser Gürtel 3, Top 2-5, 1150 Wien</p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text >
          Copyright <a style="text-decoration: none" href="https://agdavrupa.org/"><strong>Avrupa Gençlik Derneği</strong></a>  © {{ new Date().getFullYear() }}. Tüm Hakları Gizlidir
        </v-card-text>
      </v-card>
    </v-container>
    <!--<v-container class="mx-auto" >
      <v-row>
        <v-col cols="9">
          <v-btn
              v-for="(item, i) in items"
              :key="i"
              :href="item.href"
              class="ml-0 mr-3"
              color="primary"
              square
              target="_blank"
          >
            <v-icon v-text="item.icon" />
          </v-btn>
        </v-col>

        <v-spacer />

        <v-btn
            class="mr-0"
            square
            title="Go to top"
            @click="$vuetify.goTo(0)"
        >
          <v-icon>mdi-chevron-up</v-icon>
        </v-btn>
      </v-row>
      <v-row>
        <v-col :align-self="center">
          <p>Copyright <strong>Avrupa Gençlik Derneği</strong> © {{ new Date().getFullYear() }}. Tüm Hakları Gizlidir</p>
        </v-col>
      </v-row>

    </v-container>-->
  </v-footer>
</template>

<script>
export default {
  name: 'CoreFooter',

  data: () => ({
    image: require('@/assets/footer.jpg'),
    items: [
      {
        href: 'https://twitter.com/agdavrupagnclik?',
        icon: 'mdi-twitter',
        color: '#55ACEE'
      },
      {
        href: 'https://www.instagram.com/agdavrupagenclik/',
        icon: 'mdi-instagram',
        color: '#d2192e'
      },
      {
        href: 'https://www.facebook.com/AGDAvrupaGenclik/',
        icon: 'mdi-facebook',
        color: '#3B5998'
      },

    ],
  }),
}
</script>
